import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import cars from "../data/cars";
import { useLanguage } from "../context/LanguageContext";

function CarDetails() {
  const { id } = useParams();
  const { language } = useLanguage();

  const car = cars.find(
    (item) => Number(item.id) === Number(id)
  );

  const [activeImage, setActiveImage] = useState(0);

  const translations = {
    en: {
      back: "← Back to Cars",
      car: "Car",
      perDay: "per day",
      engine: "Engine",
      transmission: "Transmission",
      category: "Category",
      seats: "Seats",
      book: "Book This Car",
      gallery: "Vehicle Gallery",
      photo: "Photo",
      of: "of",
      noPhotos: "Photos coming soon",
      notFound: "Car not found",
      notFoundText:
        "The vehicle you are looking for does not exist.",
      backToFleet: "Back to Fleet",
      luxury: "Luxury",
      economic: "Economic",
      automatic: "Automat",
      manual: "Manual",
    },

    sq: {
      back: "← Kthehu te Makinat",
      car: "Makina",
      perDay: "në ditë",
      engine: "Motori",
      transmission: "Transmisioni",
      category: "Kategoria",
      seats: "Vendet",
      book: "Rezervo Këtë Makinë",
      gallery: "Galeria e Makinës",
      photo: "Foto",
      of: "nga",
      noPhotos: "Fotot do të shtohen së shpejti",
      notFound: "Makina nuk u gjet",
      notFoundText:
        "Makina që po kërkon nuk ekziston.",
      backToFleet: "Kthehu te Flota",
      luxury: "Luksoze",
      economic: "Ekonomike",
      automatic: "Automat",
      manual: "Manual",
    },
  };

  const t = translations[language];

  if (!car) {
    return (
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          padding: "80px 20px",
          textAlign: "center",
        }}
      >
        <h1>{t.notFound}</h1>

        <p
          style={{
            color: "#666",
            marginBottom: "25px",
          }}
        >
          {t.notFoundText}
        </p>

        <Link
          to="/cars"
          style={{
            display: "inline-block",
            padding: "14px 20px",
            background: "#111317",
            color: "#ffffff",
            borderRadius: "12px",
            fontWeight: "900",
          }}
        >
          {t.backToFleet}
        </Link>
      </div>
    );
  }

  const images = car.images || [];

  const nextImage = () => {
    if (images.length <= 1) return;

    setActiveImage((current) =>
      current === images.length - 1
        ? 0
        : current + 1
    );
  };

  const previousImage = () => {
    if (images.length <= 1) return;

    setActiveImage((current) =>
      current === 0
        ? images.length - 1
        : current - 1
    );
  };

  const translateCategory = (value) => {
    if (value === "Luxury") {
      return t.luxury;
    }

    if (value === "Economic") {
      return t.economic;
    }

    return value;
  };

  const translateTransmission = (value) => {
    if (value === "Automat") {
      return t.automatic;
    }

    if (value === "Manual") {
      return t.manual;
    }

    return value;
  };

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px 80px",
      }}
    >
      <Link
        to="/cars"
        style={{
          display: "inline-block",
          marginBottom: "25px",
          color: "#555",
          fontWeight: "800",
          fontSize: "14px",
        }}
      >
        {t.back}
      </Link>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: "35px",
        }}
      >
        {/* GALLERY */}
        <div
          style={{
            flex: "1 1 650px",
            minWidth: 0,
          }}
        >
          <div
            style={{
              marginBottom: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "15px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "20px",
              }}
            >
              {t.gallery}
            </h2>

            {images.length > 0 && (
              <span
                style={{
                  color: "#777",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                {t.photo} {activeImage + 1}{" "}
                {t.of} {images.length}
              </span>
            )}
          </div>

          <div
            className="car-details-main-image"
            style={{
              position: "relative",
              width: "100%",
              height: "520px",
              borderRadius: "22px",
              overflow: "hidden",
              background: "#17191d",
              border: "1px solid #e5e5e5",
            }}
          >
            {images.length > 0 ? (
              <>
                <img
                  src={images[activeImage]}
                  alt={`${car.name} ${
                    activeImage + 1
                  }`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />

                {images.length > 1 && (
                  <>
                    <button
                      type="button"
                      onClick={previousImage}
                      aria-label="Previous image"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "14px",
                        transform: "translateY(-50%)",
                        width: "46px",
                        height: "46px",
                        borderRadius: "50%",
                        border: "none",
                        background:
                          "rgba(0,0,0,0.62)",
                        color: "#ffffff",
                        cursor: "pointer",
                        fontSize: "25px",
                      }}
                    >
                      ‹
                    </button>

                    <button
                      type="button"
                      onClick={nextImage}
                      aria-label="Next image"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "14px",
                        transform: "translateY(-50%)",
                        width: "46px",
                        height: "46px",
                        borderRadius: "50%",
                        border: "none",
                        background:
                          "rgba(0,0,0,0.62)",
                        color: "#ffffff",
                        cursor: "pointer",
                        fontSize: "25px",
                      }}
                    >
                      ›
                    </button>
                  </>
                )}
              </>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                  fontWeight: "800",
                }}
              >
                {t.noPhotos}
              </div>
            )}
          </div>

          {images.length > 1 && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                overflowX: "auto",
                marginTop: "14px",
                paddingBottom: "4px",
              }}
            >
              {images.map((image, index) => (
                <button
                  type="button"
                  key={image}
                  onClick={() =>
                    setActiveImage(index)
                  }
                  style={{
                    flex: "0 0 100px",
                    height: "76px",
                    padding: 0,
                    overflow: "hidden",
                    borderRadius: "12px",
                    border:
                      activeImage === index
                        ? "3px solid #111317"
                        : "1px solid #dddddd",
                    background: "#eeeeee",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={image}
                    alt={`${car.name} thumbnail ${
                      index + 1
                    }`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* DETAILS CARD */}
        <aside
          style={{
            flex: "1 1 330px",
            maxWidth: "430px",
            width: "100%",
            background: "#ffffff",
            borderRadius: "22px",
            border: "1px solid #e5e5e5",
            padding: "28px",
            boxShadow:
              "0 8px 30px rgba(0,0,0,0.05)",
          }}
        >
          <p
            style={{
              margin: "0 0 8px",
              color: "#888",
              fontSize: "12px",
              fontWeight: "900",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            {t.car} #{car.id}
          </p>

          <h1
            style={{
              margin: "0 0 18px",
              fontSize: "clamp(31px, 4vw, 44px)",
              lineHeight: "1.05",
              letterSpacing: "-1.5px",
            }}
          >
            {car.name}
          </h1>

          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: "7px",
              marginBottom: "30px",
            }}
          >
            <strong
              style={{
                fontSize: "34px",
              }}
            >
              €{car.price}
            </strong>

            <span
              style={{
                color: "#777",
                paddingBottom: "5px",
              }}
            >
              {t.perDay}
            </span>
          </div>

          <div
            style={{
              display: "grid",
              gap: "12px",
              marginBottom: "28px",
            }}
          >
            <DetailRow
              label={t.engine}
              value={car.engine}
            />

            <DetailRow
              label={t.transmission}
              value={translateTransmission(
                car.transmission
              )}
            />

            <DetailRow
              label={t.category}
              value={translateCategory(
                car.category
              )}
            />

            {car.seats && (
              <DetailRow
                label={t.seats}
                value={car.seats}
              />
            )}
          </div>

          <Link
            to={`/booking?car=${car.id}`}
            style={{
              display: "block",
              width: "100%",
              padding: "16px",
              borderRadius: "13px",
              textAlign: "center",
              background: "#111317",
              color: "#ffffff",
              fontWeight: "900",
              fontSize: "15px",
            }}
          >
            {t.book}
          </Link>
        </aside>
      </div>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "20px",
        padding: "14px 0",
        borderBottom: "1px solid #eeeeee",
      }}
    >
      <span
        style={{
          color: "#777",
          fontSize: "14px",
        }}
      >
        {label}
      </span>

      <strong
        style={{
          textAlign: "right",
          fontSize: "14px",
        }}
      >
        {value}
      </strong>
    </div>
  );
}

export default CarDetails;